export default {
  inviteCode: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000195","邀请码") /* "邀请码" */,
  computerAdress: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000196","电脑端 地址") /* "电脑端 地址" */,
  copyLink: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000197","复制链接") /* "复制链接" */,
  mobileAdress: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000198","移动端 地址") /* "移动端 地址" */,
  copySuccesslly: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000199","复制成功") /* "复制成功" */,
  copyFailly: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500019A","复制失败") /* "复制失败" */,
  copyLinkSuccess: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500019B","复制链接成功！") /* "复制链接成功！" */
};
